import { M8PaymentTransactionDTO } from 'services/production/types';
import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

export const getPaymentTransactionsByUser = async (
  userId: number
): Promise<M8PaymentTransactionDTO[]> => {
  const response = await customFetch(
    getM8AdminURL(`getPaymentTransactionsByUser?idUser=${userId}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
};
